export const environment = {
  production: true,
  END_POINT_SSO: 'http://localhost:8089', //ur prod,
  //END_POINT_SERVICES: 'https://localhost:7020/api'
  END_POINT_SERVICES: 'https://sitricweb.azurewebsites.net/api'
};
